import { z } from 'zod'
import { createTransferSchema } from './create-transfer.schema'

export const updateTransferSchema = createTransferSchema.partial()

export type UpdateTransferDto = z.infer<typeof updateTransferSchema>
